import { call, select } from "redux-saga/effects";
import { TempIdsMap } from "../../../../api/api-slice";
import { selectComponentTempIdsMap } from "../../../../api/selectors";
import ComponentsService from "../../../../../services/ComponentsService";
import { IUpdateComponentCommand } from "@growth-machine-llc/stridist-api-client";
import { selectComponentById } from "../../../selectors/curriculum";
import { addWorkoutExercise } from "./operation";

export default function* addExerciseWorker(payload: {
  componentId: number;
  workoutSectionId: number;
  exerciseId: number;
  newExercise;
}) {
  const { componentId, workoutSectionId, exerciseId, newExercise } = payload;
  const component = yield select(selectComponentById(componentId));
  if (!component) return;

  const map: TempIdsMap = yield select(selectComponentTempIdsMap);
  const checkedComponentId = map?.[componentId] || componentId;

  const updatedContent = addWorkoutExercise(
    workoutSectionId,
    exerciseId,
    component.content,
    newExercise,
  );

  const command: IUpdateComponentCommand = {
    id: checkedComponentId,
    content: updatedContent,
  };

  try {
    yield call(ComponentsService.update, command);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
